<template>
  <SelectWithSearch
    label="Usuário"
    labelBusca="name"
    placeholder="Selecione um usuário"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :change="change"
    :options="userCollection"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
    <template slot="no-options"> Selecione um usuário </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectUser',
  components: {
    SelectWithSearch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    value: {},
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setUserCollection();
  },
  computed: {
    ...mapState('application', ['userCollection']),
  },
  methods: {
    ...mapActions('application', ['setUserCollection']),

    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
